import React, { useState} from 'react'
import { Button } from 'primereact/button'; 
import { deletePost, editPost,getOnePost } from "./../../api/axiosPosts"
// import { getAllPosts } from "../../../api/fetchPosts";
import { Link, useNavigate } from 'react-router-dom';
import DeleteDialog from '../dialogs/DeleteDialog';







const ProcessDelete = (
    {
        pkid,
        setFetcherror,
        setPosts,
        handleAllToasts,
        post,
        setPost,
       
    }) => {
    
    const [dilogvisible, setDilogvisibleVisible] = useState(false);
    const navigate = useNavigate();

    const deletefunction = (pkid, setPosts, setFetcherror, handleAllToasts) => {
        return () => {
          deletePost(pkid, setPosts, setFetcherror, handleAllToasts);
        };
    };
    
    const dialogHeader = "Confirm Delete";
    
    const dialogContents = (
        <p>Do you really want to delete this post?, Click "Yes" to Proceed or "No" to Cancel</p>
    );
    


    
    
    return (
      
        <div className='flex flex-column justify-content-between'>

        <Button
          label=""
          icon="pi pi-pencil"
          className=""
          tooltip="Edit"
                tooltipOptions={{ position: 'top' }}
                onClick={() => {
                    getOnePost(
                        pkid,
                        setFetcherror,
                        post,   
                        setPost
                    );
                    navigate(`/post/${pkid}`);
                }}
       
        />
            
         <Button
          label=""
          icon="pi pi-trash"
          className="p-button-danger mt-2"
          tooltip="Delete"
          tooltipOptions={{ position: 'top' }}
                onClick={() => {
                    // deletePost(pkid, setPosts, setFetcherror, handleAllToasts);
                    setDilogvisibleVisible(true);
                }}
        />
            
     {
                dilogvisible &&
        
                <DeleteDialog
                    dilogvisible={dilogvisible}
                    setDilogvisibleVisible={setDilogvisibleVisible}
                    deletefucton={deletefunction(pkid, setPosts, setFetcherror, handleAllToasts)}
                    dialogHeader={dialogHeader}
                    dialogContents={ dialogContents}
                    
                 />
      } 
       
       </div>
  )
}

export default ProcessDelete